import '../styles/testimonials/two.scss'

const TestimonialsTwo = () => {
  return (
    <>
    <div className="testimonials__two__container">
    <div className="testimonials__two__wrapper">
    <h1 className="testimonials__two__review">
    At this point I’m just in awe at this platform. From the emails keeping in touch and even the guidiance. What a wonderful opportunity to help my family and become the earner I know I can be. 5 stars
    </h1>
    <div className='testimonials__two__user__wrapper'>
        <figure className='testimonials__two__figure'>
            <img src="/images/avatar.png" alt="avatar" />
        </figure>

        <span className='testimonials__two__user__name__wrapper'>
            <p className='testimonials__two__user__name'>Candice Wu</p>
            <p className='testimonials__two__user__title'>Trader</p>
        </span>

        </div>
    </div>

    </div>
    </>
  )
}

export default TestimonialsTwo